import { useTranslation } from "react-i18next";
import { useFeatureFlag } from "@hooks";
import { ResponsiveDropdownItem } from "@components";

export const useNewTransactionActions = (): ResponsiveDropdownItem[] => {
  const { t } = useTranslation();
  const isPdfImportEnabled = useFeatureFlag("PDF_IMPORT");

  return [
    {
      label: t("investmentsPage.header.actions.create"),
      testId: "investment-create",
      to: "/new-transaction-wizard",
    },
    ...(isPdfImportEnabled
      ? [
          {
            label: t("investmentsPage.header.actions.uploadPdf"),
            testId: "upload-pdf",
            to: "/investments/file-drop",
          },
        ]
      : []),
    {
      label: t("investmentsPage.header.actions.uploadCsv"),
      testId: "upload-csv",
      to: "/investments/csv-drop",
    },
  ];
};
